import Link from 'next/link'

interface Props {
  path: string
  title: string
}

export const BreadcrumbItem = ({ path, title }: Props) => (
  <>
    <Link
      href={path}
      className="uppercase text-orange"
      style={{ overflowWrap: 'break-word' }}
    >
      {title}
    </Link>
  </>
)
